import { render, staticRenderFns } from "./AvatarTitle.vue?vue&type=template&id=0c65b2b2"
import script from "./AvatarTitle.vue?vue&type=script&lang=js"
export * from "./AvatarTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports